import React from 'react';

const DragIcon = (props) => {
    const { type, size = 16, fontSize = '16px' } = props;

    const renderIcon = () => {
        switch (type) {
            case 'DirectionalDrag':
                return (
                    <span className="handle" style={{ cursor: 'grab' }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 16"
                            width="18"
                            height="18"
                            zIndex='10000'
                        >
                            <path
                                fill="#008ccc"
                                d="M7.5 2.7066V6h1V2.7077L10.145 4.355l.7085-.7085-2.5-2.5a.49983.49983 0 00-.707 0l-2.5 2.5.70612.70612zM8.5 13.2934V10h-1v3.2923L5.855 11.645l-.7085.7085 2.5 2.5a.49983.49983 0 00.707 0l2.5-2.5-.70612-.70612zM14.85352 7.64648l-2.5-2.5-.70612.70612L13.2934 7.5H10v1h3.2923L11.645 10.145l.7085.7085 2.5-2.5A.49983.49983 0 0014.85352 7.64648zM6 8.5v-1H2.7077L4.355 5.855l-.7085-.7085-2.5 2.5a.49983.49983 0 000 .707l2.5 2.5.70612-.70612L2.7066 8.5z"
                            />
                        </svg>
                    </span>

                );
            case 'Drag':
                return (
                    <i className="fas fa-grip-vertical"></i>

                );
            default:
                return( <i className="fas fa-grip-vertical"></i>);
        }
    };

    return (
        <>
            {renderIcon()}
        </>
    );
};

export default DragIcon;
